import {history} from '../store/index';
import {store} from '../../NextApp';
import {generateQueryString} from "../../util/Api";

import {
  CLEAR_QR_SCAN_LOG_QUERY,
  CREATE_QR_SCAN_LOG_SUCCESS,
  FETCH_QR_SCAN_LOG_SUCCESS,
  GET_QR_SCAN_LOG_SUCCESS,
  SAVE_QR_SCAN_LOG_QUERY
} from "../../constants/ActionTypes";

import axios from 'util/Api'
import {fetchError, fetchStart, fetchSuccess} from "./Common";
import {getUser} from "./Auth";
import {message} from "antd";
import {arrayToCSV, downloadCSV} from "../../util/methods";


export const getResourceSuccess = ({data, count}) => {
  return {
    type: GET_QR_SCAN_LOG_SUCCESS,
    data,
    count
  };
};

export const saveResourceQuery = (query) => {
  return {
    type: SAVE_QR_SCAN_LOG_QUERY,
    query
  };
};

export const createResourceSuccess = ({data}) => {
  return {
    type: CREATE_QR_SCAN_LOG_SUCCESS,
    data
  };
};

export const fetchResourceSuccess = ({data}) => {
  return {
    type: FETCH_QR_SCAN_LOG_SUCCESS,
    data
  };
};

export const clearQrScanLogData = () => {
  return {
    type: CLEAR_QR_SCAN_LOG_QUERY,
  };
};


export const getResource = () => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {qrScanLog} = store.getState();
      const {query} = qrScanLog;
      const response = await axios.get(`/qr-scan-log?${generateQueryString(query)}`);

      dispatch(fetchSuccess());
      dispatch(getResourceSuccess(response.data));
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const getResourceForDownload = (columns, filters, name) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const {qrScanLog} = store.getState();
      const {query} = qrScanLog;
      const response = await axios.get(`/qr-scan-log/download?columns=${columns}&${generateQueryString(query)}`);
      dispatch(fetchSuccess());
      const str = arrayToCSV(response.data, filters, columns)
      downloadCSV(str, name);
    } catch (error) {
      message.error(error.response.data.message);
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const createResource = (payload) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.post(`/qr-scan-log`, payload);
      dispatch(fetchSuccess());
      dispatch(createResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error));
      console.log("Error****:", error);
    }
  }
};

export const updateResource = (payload, id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.put(`/qr-scan-log/${id}`, payload);
      dispatch(fetchSuccess());
      dispatch(getUser());
      history.push('/qr-scan-log');
      dispatch(getResource());
    } catch (error) {
      console.log("Error****:", error);
      dispatch(fetchError(error.response.data.message));
    }
  }
};


export const fetchResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      const response = await axios.get(`/qr-scan-log/${id}`);
      dispatch(fetchSuccess());
      dispatch(fetchResourceSuccess({data: response.data}));
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};

export const deleteResource = (id) => {
  return async (dispatch) => {

    dispatch(fetchStart());

    try {
      await axios.delete(`/qr-scan-log/${id}`);
      dispatch(fetchSuccess());
      dispatch(getResource());
    } catch (error) {
      dispatch(fetchError(error.response.data.message));
      console.log("Error****:", error.response.data.message);
    }
  }
};
